import { DomainOriginType } from "@porchpass/api-client";
import {
  ORIGIN_DGA_BG,
  ORIGIN_DGA_TEXT,
  ORIGIN_DLA_BG,
  ORIGIN_DLA_TEXT,
  ORIGIN_DIGIFI_BG,
  ORIGIN_DIGIFI_TEXT,
} from "./colors";

export interface ApplicationOriginStyle {
  label: string;
  backgroundColor: string;
  textColor: string;
}

const APPLICATION_ORIGIN_STYLES: Record<string, ApplicationOriginStyle> = {
  [DomainOriginType.OriginDGA]: {
    label: "Dealer",
    backgroundColor: ORIGIN_DGA_BG,
    textColor: ORIGIN_DGA_TEXT,
  },
  [DomainOriginType.OriginDLA]: {
    label: "Customer",
    backgroundColor: ORIGIN_DLA_BG,
    textColor: ORIGIN_DLA_TEXT,
  },
  [DomainOriginType.OriginDigifi]: {
    label: "DigiFi",
    backgroundColor: ORIGIN_DIGIFI_BG,
    textColor: ORIGIN_DIGIFI_TEXT,
  },
};

export function getApplicationOriginStyle(
  origin?: string | null,
): ApplicationOriginStyle | null {
  if (!origin) return null;
  return APPLICATION_ORIGIN_STYLES[origin] ?? null;
}
